import { herbFilter } from '../sections/hrg-filter';
import { herbSearch } from '../sections/hrg-search';

herbSearch();
herbFilter();
